<template>
  <v-container>
    <v-footer padless>
      <v-card flat class="text-center  white--text black " width="100%">
        <v-card-text class=" mt-0">
          <h4 class="white--text">Contact me:</h4>
          <v-btn
            v-for="icon in links"
            :key="icon.icon"
            class="mx-4 "
            color="#00796B"
            icon
            :href="icon.link"
            target="_blank"
          >
            <v-icon size="24px">{{ icon.icon }}</v-icon>
          </v-btn>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} —
          <strong>Yared Weldegebrial ( Gmail: yared12707@gmail.com)</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  name: "Header",
  data: () => ({
    links: [
      {
        icon: "mdi-facebook",
        link: "https://www.facebook.com/yared.weldegebrial/",
      },
      { icon: "fab fa-twitter", link: "https://twitter.com/YWeldegebrial" },
      {
        icon: "fab fa-linkedin",
        link: "https://www.linkedin.com/in/yared-weldegebrial-a6b491175",
      },
      {
        icon: "fab fa-instagram",
        link: "https://www.instagram.com/yaredaseeker/",
      },
      {
        icon: "fab fa-github",
        link: "https://github.com/yaredweldegebrialreda",
      },
      //  { icon: "fab fa-gmail", link: "yared12707@gmail.com" }
    ],
  }),
};
</script>
